export const GLOBAL_PAGE_WRAPPER_ID = 'global-page-wrapper';

export const HEADER_SEARCH_FIELD_ID = 'header-search-field';
export const HEADER_SEARCH_FIELD_MOBILE_ID = 'header-search-field-small';

export const HEADER_MAIN_NAVIGATION_ID = 'header-main-nav';

export const MAIN_CONTENT_CONTAINER_ID = 'main';

export const MODALS_CONTAINER_ID = 'modals-container';

export const PRODUCT_DETAILS_ACCESSORIES_ID = 'accessories';
export const PRODUCT_DETAILS_IMPORTANT_INFO_ID = 'important-information';
export const PRODUCT_DETAILS_SIMILAR_PRODUCTS_ID = 'similar-products';
export const PRODUCT_DETAILS_TECHNICAL_ATTRIBUTES_ID = 'technical-attributes';
export const PRODUCT_DETAILS_SPARE_PARTS_ID = 'spare-parts';
export const PRODUCT_DETAILS_BELONGS_TO_ID = 'belongs-to';
export const PRODUCT_DETAILS_BELONGS_TO_BUNDLE_ID = 'belongs-to-bundle';
